var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextbook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "600px",
    height: "800px",
    viewBox: "8 0 34 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b6ea4;}.cls-2{fill:#445f96;}.cls-3{fill:#a09b8c;}.cls-4{fill:#f1f2f2;}.cls-5{fill:#4c5665;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Book"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 48,
    rx: 2,
    ry: 2,
    width: 34,
    x: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,0h2a0,0,0,0,1,0,0V48a0,0,0,0,1,0,0H10a2,2,0,0,1-2-2V2A2,2,0,0,1,10,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40,44H10a2,2,0,0,0,0,4H40a2,2,0,0,0,2-2V42A2.006,2.006,0,0,1,40,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40,44H10a2,2,0,0,0,0,4H40a2,2,0,0,0,2-2V42A2.006,2.006,0,0,1,40,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42,44v2a2.006,2.006,0,0,1-2,2H10a2,2,0,0,1-1.73-3A2,2,0,0,0,10,46H40A2.006,2.006,0,0,0,42,44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 10,
    rx: 1,
    ry: 1,
    width: 19,
    x: 17,
    y: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextbook);
export default __webpack_public_path__ + "static/media/textbook.4c9d5653d8029c48354b7871ee17ddc3.svg";
export { ForwardRef as ReactComponent };